import { footerData } from '@/mocks/home';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                每日大赛
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed mb-4">
              {footerData.description}
            </p>
            <p className="text-xs text-foreground-500">
              {footerData.slogan}
            </p>
          </div>

          {footerData.links.map((group, i) => (
            <div key={i}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">
                {group.title}
              </h4>
              {group.items.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.items.map((item, j) => (
                    <li key={j}>
                      <a
                        href={item.href}
                        onClick={(e) => handleClick(e, item.href)}
                        className="text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-xs md:text-sm text-foreground-500">
                  虚位以待，期待优质伙伴加入
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-700/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 每日大赛官网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              onClick={(e) => handleClick(e, '#contact')}
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
            >
              侵权投诉
            </a>
            <a
              href="#faq"
              onClick={(e) => handleClick(e, '#faq')}
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
            >
              常见问题
            </a>
            <a
              href="#about"
              onClick={(e) => handleClick(e, '#about')}
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
            >
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}